import { Alert, Modal, Radio } from 'antd'
import React, { FC, useState } from 'react'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import { useMergeLeadsMutation } from '../api'
import { TGetLeads } from '../types'

const MergeLeads: FC<{
 onCancel: () => void
 selectedLeads?: TGetLeads[]
 refetch?: () => void
}> = ({ onCancel, selectedLeads, refetch }) => {
 const [mergeLeadsMutation, { isLoading }] = useMergeLeadsMutation()
 const [mainLead, setMainLead] = useState<null | number>(null)
 const handleMergeLeads = async (): Promise<void> => {
  await mergeLeadsMutation({
   parent_id: mainLead as number,
   merge_ids: selectedLeads
    ?.map((lead) => lead?.id)
    ?.filter((id) => id !== mainLead),
  }).unwrap()
  onCancel()
  refetch?.()
 }
 const isTransferLeadIncluded = !!selectedLeads?.find((v) => !!v.transferowner)

 const excludedTransferLeads = selectedLeads?.filter((v) => !v.transferowner)

 return (
  <Modal
   confirmLoading={isLoading}
   okButtonProps={{ disabled: !mainLead }}
   onOk={handleMergeLeads}
   okText={`Yes, Merge ${
    excludedTransferLeads && excludedTransferLeads?.length > 1
     ? excludedTransferLeads?.length ?? 0
     : ''
   } Leads`}
   visible
   title="Merge Leads"
   onCancel={onCancel}
  >
   <div>
    <p> Select the main lead to merge data to:</p>
    <Radio.Group
     onChange={({ target }) => {
      setMainLead(target?.value)
     }}
     className="w-100"
    >
     {selectedLeads?.map((lead, n) => (
      <div
       key={n}
       className={`p-2 my-2 ${lead?.id === mainLead ? 'border-danger' : ''}`}
       style={{ border: '1px solid #ccc' }}
      >
       <Radio
        className="lead-merge-item-blk"
        value={lead?.id}
        disabled={
         !!lead.transferowner ||
         (excludedTransferLeads && excludedTransferLeads?.length === 1)
        }
       >
        <AvatarStatus
         title={lead?.name}
         showTooltip
         content={
          <>
           {lead?.email_address?.email && (
            <span>
             <i className="fas fa-envelope pe-1" style={{ fontSize: '12px' }} />
             {`${lead?.email_address?.email}${
              lead?.phone_number?.number ? ',' : ''
             }`}
            </span>
           )}
           {lead?.phone_number?.number && (
            <span className="ps-2">
             <i
              className="fas fa-phone-alt pe-1"
              style={{ fontSize: '12px' }}
             />
             {lead?.phone_number?.number}
            </span>
           )}
          </>
         }
        />
       </Radio>
      </div>
     ))}
    </Radio.Group>
    <div className="mt-3">
     <Alert
      type="error"
      showIcon
      message="Transferred leads cannot be merged and are excluded from selection."
     />
     <Alert
      type="warning"
      showIcon
      className="mt-2"
      message="Contact information and associated activities will be transferred to the
      main lead. Action plans, alerts, stage, tags, sources, tasks,
      appointments, newsletters, market update and scheduled items will be
      discarded permanently. This action cannot be undone."
     />
     {/* <p>
      <i className="fas fa-exclamation-triangle pe-2" />
      Transferred leads cannot be merged and are excluded from selection.
     </p> */}
     {/* <p>
      <i className="fas fa-exclamation-triangle pe-2" />
      Contact information and associated activities will be transferred to the
      main lead. Action plans, alerts, stage, tags, sources, tasks,
      appointments, newsletters, market update and scheduled items will be
      discarded permanently. This action cannot be undone.
     </p> */}
    </div>
   </div>
  </Modal>
 )
}

export default MergeLeads
